const name = 'README.md'
const text = `# My API Playground


`
const template = { name, text }
export default template
